export default __webpack_public_path__ + "static/media/trip-planner.b9b6d6c2.svg";